import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { DecimalPipe } from "@angular/common";

import { DocTarea } from "../../shared/model/iso42001/homologacion-modelo.model";

type Nivel = "alto" | "medio" | "bajo" | "na";

/**
 * La vista rápida de dónde está fuerte o débil un modelo: tareas en las
 * filas, rubros en las columnas y color por valor (≥ 90 verde, ≥ 75 ámbar,
 * menos rojo; sin valor, gris y «no aplica»). El número va siempre escrito:
 * el color no es la única señal.
 */
@Component({
  selector: "app-matriz-tarea-rubro",
  standalone: true,
  imports: [DecimalPipe],
  templateUrl: "./matriz-tarea-rubro.component.html",
  styleUrls: ["./matriz-tarea-rubro.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MatrizTareaRubroComponent {
  @Input() tareas: DocTarea[] = [];
  @Input() rubros: { id: string; nombre: string }[] = [];

  valor(t: DocTarea, rubro: string): number | null {
    const v = t?.obtenido?.rubros?.[rubro];
    return typeof v === "number" && Number.isFinite(v) ? v : null;
  }

  nivel(v: number | null): Nivel {
    if (v == null) {
      return "na";
    }
    return v >= 90 ? "alto" : v >= 75 ? "medio" : "bajo";
  }
}
